import { useContext } from "react";
import { UserContext } from "../../../context/UserContext";
import useRequestsByProvider from "../../../hooks/useRequestsByProvider";
import RequestsTable from "../../../components/RequestsTable/RequestsTable";
import { BASE_URL } from "../../../constants";

const PendingConfirmation = () => {
  const {
    user: { medical_provider_id: providerId },
  } = useContext(UserContext);

  const { requests, reloadRequests } = useRequestsByProvider(
    providerId,
    "Pending"
  );

  const handleAccept = async (req) => {
    await fetch(`${BASE_URL}/api/requests/${req.request_id}/accept`, {
      method: "PUT",
    });
    reloadRequests();
  };

  const handleReject = async (req) => {
    await fetch(`${BASE_URL}/api/requests/${req.request_id}/reject`, {
      method: "PUT",
    });
    reloadRequests();
  };

  return (
    <RequestsTable
      title="Pending Confirmation Requests"
      requests={requests}
      onAccept={handleAccept}
      onReject={handleReject}
      showActions={true}
    />
  );
};

export default PendingConfirmation;
